import React, {Component} from 'react';
import "./GeographicFilter.css"
import "./commonAnalysisStyle.css"
import "./css/mapbox-gl.css"
import $ from "jquery";

const mapboxgl = require('mapbox-gl')


class GeographicFilter extends Component {
    map = undefined


    constructor(props) {
        super(props);
        this.state = {geofeatures: {},extraction : 'publishing'};

    }


    componentDidMount() {


    }

    handleOptionChange  = (changeEvent) =>{
        this.setState({
            extraction: changeEvent.target.value
        },() =>{

            this.props.changeGeographicExtraction(this.state.extraction);
            //console.log(this.state.extraction);
        });

    }

    update(parameters) {


        let serviceUrl = window.apiAlcideUrlPrefix + "metadataGeonames"
        if (this.state.extraction !== 'publishing'){
            serviceUrl = window.apiAlcideUrlPrefix + "citedGeonames"
        }

        if (this.map === undefined) {

            let widget = this

            this.map = new mapboxgl.Map({
                container: 'mappa',
                style: 'https://dh-server.fbk.eu/tiles/styles/alcide-map/style.json',
                attributionControl: false
            });

            this.map.scrollZoom.disable();
            this.map.addControl(new mapboxgl.NavigationControl(), 'bottom-left');
            this.map.on('load', () => {

                // Add a new source from our GeoJSON data and set the
                // 'cluster' option to true. GL-JS will add the point_count property to your source data.
                this.map.addSource('markers', {
                    'type': 'geojson',
                    'data': {
                        'type': 'FeatureCollection',
                        'features': []
                    },
                    'cluster': true,
                    'clusterMaxZoom': 5,
                    'clusterRadius': 50
                });


                this.map.addLayer({
                    id: "clusters",
                    type: "circle",
                    source: "markers",
                    filter: ["has", "point_count"],
                    paint: {
                        "circle-color": {
                            property: "point_count",
                            type: "interval",
                            stops: [
                                [0, "#9fd673"],
                                [100, "#f19b4a"],
                                [750, "#f2d262"],
                            ]
                        },
                        "circle-radius": {
                            property: "point_count",
                            type: "interval",
                            stops: [
                                [0, 20],
                                [100, 30],
                                [750, 40]
                            ]
                        }
                    }
                });

                this.map.addLayer({
                    id: "cluster-count",
                    type: "symbol",
                    source: "markers",
                    filter: ["has", "point_count"],
                    layout: {
                        "text-field": "~{point_count_abbreviated}",
                        "text-font": ["Open Sans Regular"],
                        "text-size": 12
                    }
                });

                this.map.addLayer({
                    id: "unclustered-point",
                    type: "circle",
                    source: "markers",
                    filter: ["!has", "point_count"],
                    paint: {
                        "circle-color": "#9960da",
                        "circle-radius": 6,
                        "circle-stroke-width": 1,
                        "circle-stroke-color": "#fff"
                    }
                });







                var popup = new mapboxgl.Popup({
                    closeButton: false,
                    closeOnClick: false
                });


                this.map.on('click', 'clusters', function (e) {
                    console.log(e);
                    var cluster = e.target.queryRenderedFeatures(e.point, {layers: ["clusters"]});

                    if (cluster[0]) {
                        var pointsInCluster = features.filter(function (f) {
                            var pointPixels = e.target.project(f.geometry.coordinates)
                            var pixelDistance = Math.sqrt(
                                Math.pow(e.point.x - pointPixels.x, 2) +
                                Math.pow(e.point.y - pointPixels.y, 2)
                            );
                            return Math.abs(pixelDistance) <= 60;
                        });
                        console.log(cluster, pointsInCluster);
                    }
                })

                this.map.on('click', 'unclustered-point', function (e) {
                     widget.props.callbackParent(e);
                });


                this.map.on('mouseenter', 'unclustered-point', function (e) {
                    e.target.getCanvas().style.cursor = 'pointer';
                    popup.setLngLat(e.features[0].geometry.coordinates)
                        .setHTML("<p style='color: #202020; z-index: 100000 '>" + e.features[0].properties.name + "</p>")
                        .addTo(e.target);
                });
                this.map.on('mouseleave', 'unclustered-point', function (e) {
                    popup.remove()

                });



                let param = parameters
                let geoFeats = {}
                let features = []
                let mappa = this.map
                $.ajax({
                    type: "POST",
                    url: serviceUrl,
                    data: param,
                    async: true,
                    dataType: "json",
                    success: function (data) {
                        geoFeats = {
                            type: "FeatureCollection",
                            features: data.geoFeatures,
                            crs: {"type": "name", "properties": {"name": "urn:ogc:def:crs:OGC:1.3:CRS84"}}
                        }
                        geoFeats.type = "FeatureCollection"
                        geoFeats.features = data.geoFeatures
                        features = data.geoFeatures
                        mappa.getSource('markers').setData(geoFeats);

                    }
                });





            });
        } else {
            let param = parameters
            let geoFeats = {}
            let mappa = this.map
            $.ajax({
                type: "POST",
                url: serviceUrl,
                data: param,
                async: true,
                dataType: "json",
                success: function (data) {
                    geoFeats = {
                        type: "FeatureCollection",
                        features: data.geoFeatures,
                        crs: {"type": "name", "properties": {"name": "urn:ogc:def:crs:OGC:1.3:CRS84"}}
                    }
                    geoFeats.type = "FeatureCollection"
                    geoFeats.features = data.geoFeatures
                    try {
                        mappa.getSource('markers').setData(geoFeats);
                    }catch (e) {

                    }
                }
            });


        }


    }


    render() {
        return (
            <div id="geoDashboard" className="GeographicalWidgetStyle commonAnalysisFeatures">

                <center>
                    <div className="analisysTitle">Luoghi</div>
                </center>
                <div id="mappa"></div>

                <div className="radioList">

                <input className="magic-radio" type="radio" name="radio" id="1" value="publishing" checked={this.state.extraction === 'publishing'}  onChange={this.handleOptionChange}/>
                <label htmlFor="1">
                    Luoghi di pubblicazione
                </label>
                <input className="magic-radio" type="radio" name="radio" id="2" value="cited" checked={this.state.extraction === 'cited'} onChange={this.handleOptionChange}/>
                <label htmlFor="2">
                    Luoghi menzionati
                </label>
                </div>

            </div>
        );
    }
}

export default GeographicFilter;


// WEBPACK FOOTER //
// ./src/components/GeographicFilter.jsx